import Chart from "react-apexcharts";

const BarChart = () => {
  const options = {
    chart: {
      //   height: 350,
      type: "bar",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false, // This hides the toolbar and the hamburger menu
      },
    },
    grid: {
      show: false, // This removes the grid lines
      borderColor: "#ffffff", // Optional: set border color if needed
      strokeDashArray: 0, // Optional: set to 0 for solid lines if needed
    },
    colors: ["#00BAD1"],
    plotOptions: {
      bar: {
        borderRadius: 16,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: string) {
        return val + "%";
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },

    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      //   position: "top",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      //   crosshairs: {
      //     fill: {
      //       type: "gradient",
      //       gradient: {
      //         colorFrom: "#D8E3F0",
      //         colorTo: "#BED1E6",
      //         stops: [0, 100],
      //         opacityFrom: 0.4,
      //         opacityTo: 0.5,
      //       },
      //     },
      //   },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    // title: {
    //   text: "Monthly Inflation in Argentina, 2002",
    //   floating: true,
    //   offsetY: 330,
    //   align: "center",
    //   style: {
    //     color: "#444",
    //   },
    // },
  };

  const series = [
    {
      name: "Inflation",
      data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2, 2.3, 1.4, 0.8, 0.5, 0.2],
    },
  ];

  return <Chart options={options} series={series} type="bar" />;
};

export default BarChart;
